/* eslint-disable react/jsx-no-target-blank */
import {
  Button,
  Container,
  Dimmer,
  Grid,
  Icon,
  Table,
  Loader,
  Segment,
  Header,
  Modal,
  Item,
  Label,
  Form,
  Divider,
  Checkbox,
} from 'semantic-ui-react';

import React, {
  Component,
} from 'react';
import PropTypes from 'prop-types';
import qs from 'qs';
import moment from 'moment-timezone';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import { Link } from 'react-router';
import { flashMessage, flashSuccessMessage, flashErrorMessage } from '../../actions/flash';
import { decodeSearch, encodeSearch, AWSUrl } from '../../utils/url';
import isbase64 from '../../utils/isbase64';
import { promptChangesMessage } from '../../actions/prompt';
import { SearchList } from '../../components/Filters';
import Timestamp from '../../components/Timestamp';
import PageNav from '../../components/PageNav';
import NavBar from '../../components/NavBar';
import SearchFilter from '../../components/SearchFilter';
import SortButton from '../../components/SortButton';
import LoanAmount from '../../components/LoanAmount';
import SearchStaff from '../../components/SearchStaff';
import CurrencySymbol from '../../components/CurrencySymbol';
import BookingFeePaymentList from '../../components/BookingFeePaymentList';
import { fetchM } from '../../actions/fetchM';
import { isNumeric } from '../../utils/numbers/isNumber';
import { getItem, setItem } from '../../utils/storage';
import { centsToFloat } from '../../utils/numbers/centsFloat';
import { spaFullNumber } from '../../utils/amount';
import config from '../../../config';
import PAYMENT_STATUSES from '../../constants/paymentStatuses';
import {
  UPLOAD_PICTURE_PROMPT,
} from '../../constants/promptMessages';
import LoadImage from '../../components/LoadImage';
import valueToText from '../../utils/valueToText';

moment.locale('en-gb');

class ManageOld extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    appConfig: PropTypes.shape({}),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
    }),
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const token = '';
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const advanceFilter = false;
    const projectFilter = (isbase64(query.projectFilter) && qs.parse(atob(query.projectFilter)).name) || '';
    const modal = {
      isOpen: false,
      header: '',
      headerIcon: 'warning sign',
      message: '',
      actionButtonText: 'Yes',
      unitID: '',
      bookingID: '',
      notes: '',
      isCancelPending: true,
    };
    const paymentModal = {
      isOpen: false,
      bookingID: '',
      unitID: '',
    };
    return {
      token,
      modal,
      paymentModal,
      currentPage,
      search,
      advanceFilter,
      projectFilter,
      loadingSearch: false,
      findProjectResults: [],
      noResultsMessage: 'Loading...',
    };
  }
  constructor(props) {
    super(props);
    const state = Manage.getPropsToState(props);
    state.data = [];
    this.state = {
      loading: true,
      bookingPaymentToken: '',
      bookingPaymentData: '',
      showLarge: false,
      selectedPicture: null,
      slideshow: false,
      count: 0,
      limit: 10,
      offset: 0,
      ...state,
      autoReload: false,
      customerData: [],
      isDuplicate: false,
    };
    const query = decodeSearch(props.location.search);
    if ((query.projectFilter && query.projectFilter.length > 0)) {
      this.state.advanceFilter = true;
    }
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    this.fetchProjectUnitBookings(query);
    const localAutoReloadValue = getItem(`${config.get('appName')}.bookingManageAutoReload`);
    if (localAutoReloadValue === 'true') {
      this.state.autoReload = true;
      this.setRefreshDataTimeout();
    }
  }
  componentWillReceiveProps(nextProps) {
    const state = Manage.getPropsToState(nextProps);
    const query = decodeSearch(nextProps.location.search);
    if (this.state.limit < 0) {
      this.fetchProjectUnitBookings(query);
      state.loading = this.state.loading;
    }
    state.token = this.state.token;
    if ((query.projectFilter && query.projectFilter.length > 0)) {
      state.advanceFilter = true;
    }
    this.setState({ ...state });
  }
  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
  }
  getSelectedStaffValue = () => {
    const { bookingPaymentData } = this.state;
    const selectedStaffValue = {
      key: bookingPaymentData.assignedMaUserID.toString() || 0,
      title: bookingPaymentData.assignedMaName || '',
      price: bookingPaymentData.assignedMaPreferredName || '',
    };
    return selectedStaffValue;
  }
  setLoadingSearch(loadingSearch = false) {
    return new Promise((res) => {
      this.setState({ loadingSearch }, res);
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, res);
    });
  }
  setBookings(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, res);
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, res);
    });
  }
  setRefreshDataTimeout = () => {
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
    this.timeoutRefresh = setTimeout(() => {
      this.handleRefreshData();
      this.setRefreshDataTimeout();
    }, 30000); // 30 seconds auto refresh time
  }
  isChequeDuplicated = (data) => {
    const { bookingFeePayments } = data;
    return (Array.isArray(bookingFeePayments) && bookingFeePayments.length > 0 && bookingFeePayments.some(bfp => bfp.isChequeDuplicate && ['cancelled', 'deduction'].every(s => bfp.status !== s)))
  }
  async fetchPrimaryBookingCustomer() {
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/customers/${this.state.bookingPaymentData.customerID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    const json = await res.json();
    if (json) {
      const newCustData = Object.assign({}, json || {});
      this.setState({ customerData: newCustData });
    }
    await this.setLoading(false);
  }
  async fetchProjectUnitBookings(q, silentLoad = false) {
    if (!silentLoad) {
      await this.setLoading(true);
    }
    const { store } = this.context;
    const query = Object.assign({}, q);
    if (!query.page || !isNumeric(query.page) || query.page <= 0) {
      query.page = 1;
    }
    let res;
    try {
      const url = '/manage/project_units/';
      let queryString = '';
      if (qs.stringify(query)) {
        queryString = `?${qs.stringify(query)}`;
      }
      res = await store.dispatch(fetchM(`${url}${queryString}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10);
      const data = await res.json();
      await this.setBookings(data);
      await this.setComponentState({
        token,
        count,
        limit,
        offset,
      });
    }
    await this.setLoading(false);
  }
  async putBoooking(bookingData, unitID, bookingID, type, silentLoad = false) {
    const { store } = this.context;
    if (!silentLoad) {
      await this.setLoading(true);
    }
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/manage/project_units/${unitID}/bookings/${bookingID}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
        body: JSON.stringify(bookingData),
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    const respondData = await res.json();
    const query = decodeSearch(this.props.location.search);
    const modal = Object.assign({}, this.state.modal);
    if (this.state.data) {
      const { data } = this.state;
      data.map((unit, idx) => {
        if (unit.id === modal.unitID) {
          // Hide all cancelled bookings by same units
          if (modal.type === 'approve') {
            unit.bookings.map((booking, idxb) => {
              const updatedBooking = booking;
              if (booking.id === modal.bookingID) {
                updatedBooking.approve = true;
              } else {
                updatedBooking.decline = true;
              }
              data[idx].bookings[idxb] = updatedBooking;
              return null;
            });
          }
          if (modal.type === 'decline') {
            unit.bookings.map((booking, idxb) => {
              if (booking.id === modal.bookingID) {
                const updatedBooking = booking;
                updatedBooking.decline = true;
                data[idx].bookings[idxb] = updatedBooking;
              }
              return null;
            });
          }
        }
        return null;
      });
      this.setState({ data }, () => {
        modal.unitID = '';
        modal.bookingID = '';
        this.setState({ modal });
      });
    }
    await this.setLoading(false);
    store.dispatch(flashMessage({
      header: type === 'approve' ? 'Booking Confirmed' : 'Resevation Cancelled',
      message: type === 'approve' ? `Booking ${respondData.code} successfully confirmed` : `Resevation ${respondData.code} has been declined`,
      icon: type === 'approve' ? 'checkmark' : 'x',
      type: 'success',
      autoHideDuration: 5000,
    }));
    if (this.state.autoReload) {
      this.timeout = setTimeout(() => {
        query.page = 1;
        this.fetchProjectUnitBookings(query, true);
        store.dispatch(replace(`/bookings/manage/?${encodeSearch(query)}`));
      }, 4000);
    }
  }
  async fetchBookingPayment(bookingID) {
    await this.setLoading(true);
    const { store } = this.context;
    let res;
    try {
      res = await store.dispatch(fetchM(`/bookings/${bookingID}/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const bookingPaymentToken = res.headers.get('X-Csrf-Token');
      const bookingPaymentData = await res.json();
      await this.setComponentState({
        bookingPaymentToken,
        bookingPaymentData,
      });
      if (this.isChequeDuplicated(bookingPaymentData)) {
        await this.setComponentState({
          isDuplicate: true,
        });
      }
      await this.fetchPrimaryBookingCustomer();
    }
    await this.setLoading(false);
  }
  async updateBookingPayment(bookingPaymentData, xid = this.state.data.id) {
    await this.setLoading(true);
    const query = decodeSearch(this.props.location.search);
    const payData = bookingPaymentData;
    payData.paymentAmount = parseFloat(payData.paymentAmount);
    const { store } = this.context;
    let res = '';
    try {
      res = await store.dispatch(fetchM(`/bookings/${xid}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.bookingPaymentToken,
        },
        body: JSON.stringify(bookingPaymentData),
      }));
    } catch (err) {
      await this.setLoading(false);
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
      return;
    }
    const respData = await res.json();
    if (this.state.data) {
      const { data, paymentModal } = this.state;
      data.map((unit, idx) => {
        if (unit.id === paymentModal.unitID) {
          unit.bookings.map((booking, idxb) => {
            const updatedBooking = booking;
            if (booking.id === paymentModal.bookingID) {
              updatedBooking.paymentStatus.name = respData.paymentStatusID
              .split(' ').map(w => w[0].toUpperCase() + w.substr(1).toLowerCase()).join(' ');
              updatedBooking.paymentStatus.id = respData.paymentStatusID;
              updatedBooking.paymentStatusID = respData.paymentStatusID;
            }
            data[idx].bookings[idxb] = updatedBooking;
            return null;
          });
        }
        return null;
      });
      paymentModal.unitID = '';
      paymentModal.bookingID = '';
      paymentModal.isOpen = false;
      this.setState({
        data,
        paymentModal,
        bookingPaymentData: '',
      }, () => {
        if (this.state.autoReload) {
          this.setRefreshDataTimeout();
        }
      });
    }
    await this.setLoading(false);
    store.dispatch(flashSuccessMessage({ header: 'Update Success', message: `Booking ${respData.code} successfully updated.` }));
    this.fetchProjectUnitBookings(query);
  }
  hasStaffAccess() {
    if (this.props.auth.isBranchLeader) {
      return false;
    }
    return true;
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.pushQuery(query);
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    this.setState({
      search: '',
    }, () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    this.replaceQuery(query, true);
  }
  handleSetAdvanceFilter = (advanceFilter) => {
    this.setState({
      advanceFilter,
    });
  }
  handleCloseModal = () => {
    const modal = Object.assign({}, this.state.modal);
    modal.isOpen = false;
    modal.notes = '';
    this.setState({ modal });
  }
  handleOpenModal = (
    unitID,
    bookingID,
    notes,
    actionButtonText,
    headerIcon,
    header,
    message,
    type,
  ) => {
    const modal = Object.assign({}, this.state.modal);
    modal.unitID = unitID;
    modal.bookingID = bookingID;
    modal.notes = notes;
    modal.isOpen = true;
    modal.header = header;
    modal.message = message;
    modal.headerIcon = headerIcon;
    modal.actionButtonText = actionButtonText;
    modal.isCancelPending = false;
    if (type === 'approve') {
      modal.type = 'approve';
      this.setState({ modal });
    } else if (type === 'decline') {
      modal.isCancelPending = true;
      modal.type = 'decline';
      this.setState({ modal });
    }
  }
  handleConfirm = () => {
    const modal = Object.assign({}, this.state.modal);
    if (modal.notes === '') {
      const { store } = this.context;
      store.dispatch(flashErrorMessage({ header: 'Please fix form errors', message: 'Notes required' }));
      return;
    }
    modal.isOpen = false;
    let statusID;
    let isCancelPending = false;
    if (modal.type === 'approve') {
      statusID = 'booked';
    }
    if (modal.type === 'decline') {
      statusID = 'cancelled_developer';
      if (modal.isCancelPending) {
        isCancelPending = true;
      }
    }
    const bookingData = {
      statusID,
      remarkInternal: modal.notes,
      isCancelPending,
    };
    this.setState({ modal }, () => {
      this.putBoooking(bookingData, modal.unitID, modal.bookingID, modal.type, true);
    });
  }
  handleSearchProject = (value) => {
    clearTimeout(this.setTimer);
    // always reset results to null before finding
    const findProjectResults = [];
    const noResultsMessage = 'Loading...';
    this.setState({ findProjectResults, noResultsMessage, projectFilter: value }, () => {
      if (value !== '') {
        this.setTimer = setTimeout(() => {
          this.searchProjects(value);
        }, 500);
      }
    });
  }
  handleSelectProject = (project, queryName) => {
    const query = decodeSearch(this.props.location.search);
    const internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(qs.stringify(internalQuery));
    this.replaceQuery(query, true);
  }
  async searchProjects(value) {
    const { store } = this.context;
    await this.setLoadingSearch(true);
    let res = null;
    try {
      res = await store.dispatch(fetchM(`/search/projects/?limit=3&search=${value}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoadingSearch(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: 'There was an error with your request. Please try again.' }));
    }
    if (!res.ok) {
      await this.setLoadingSearch(false);
      throw new Error('Not OK');
    } else {
      await this.setLoadingSearch(false);
      const json = await res.json();
      if (json) {
        const findProjectResults = json.map((obj) => {
          const newResults = {};
          newResults.key = obj.id;
          newResults.title = obj.shortName;
          newResults.description = obj.state;
          if (obj.pictureKey !== '') {
            newResults.image = AWSUrl(this.props.appConfig, `${obj.pictureKey}010.jpg`);
          } else {
            newResults.image = '/assets/images/placeholder_x100.jpg';
          }
          return newResults;
        });
        this.setState({ findProjectResults });
      } else {
        const noResultsMessage = 'No results found.';
        this.setState({ noResultsMessage });
      }
    }
  }
  handleRefreshData = () => {
    const { store } = this.context;
    const query = decodeSearch(this.props.location.search);
    query.page = 1;
    this.fetchProjectUnitBookings(query);
    store.dispatch(replace(`/bookings/manage/?${encodeSearch(query)}`));
  }
  handleAutoReload = () => {
    const autoReload = !this.state.autoReload;
    this.setState({ autoReload }, () => {
      setItem(`${config.get('appName')}.bookingManageAutoReload`, autoReload ? 'true' : 'false');
      // if autoReload is disabled when there is an ongoing timeout then..
      // ..clear the timeout also.
      if (autoReload) {
        this.handleRefreshData();
        this.setRefreshDataTimeout();
      } else {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        if (this.timeoutRefresh) {
          clearTimeout(this.timeoutRefresh);
        }
      }
    });
  }
  handleOpenPaymentModal = (bookingID, unitID) => {
    const paymentModal = {
      isOpen: true,
      bookingID,
      unitID,
    };
    this.setState({ paymentModal }, () => {
      this.fetchBookingPayment(bookingID);
    });
    if (this.timeoutRefresh) {
      clearTimeout(this.timeoutRefresh);
    }
  }
  handleSavePaymentModal = () => {
    const { bookingPaymentData, paymentModal } = this.state;
    this.updateBookingPayment(bookingPaymentData, paymentModal.bookingID);
  }
  handleClosePaymentModal = () => {
    const bookingPaymentData = '';
    const paymentModal = {
      isOpen: false,
      bookingID: '',
      unitID: '',
    };
    this.setState({ paymentModal, bookingPaymentData, isDuplicate: false }, () => {
      if (this.state.autoReload) {
        this.setRefreshDataTimeout();
      }
    });
  }
  handlePaymentChange = (event, value) => {
    const { bookingPaymentData } = this.state;
    bookingPaymentData[value.name] = value.value;
    this.setState({ bookingPaymentData });
  }
  handlePaymentAmountChange = (event, value) => {
    if (isNumeric(value.value) || value.value === '') {
      const { bookingPaymentData } = this.state;
      bookingPaymentData[value.name] = value.value;
      this.setState({ bookingPaymentData });
    }
  }
  handleStaffClear = () => {
    const { bookingPaymentData } = this.state;
    bookingPaymentData.assignedMaName = '';
    bookingPaymentData.assignedMaPreferredName = '';
    bookingPaymentData.assignedMaUserID = 0;
    this.setState({ bookingPaymentData });
  }
  handleStaffSelect = (value) => {
    const { bookingPaymentData } = this.state;
    bookingPaymentData.assignedMaName = value.title;
    bookingPaymentData.assignedMaPreferredName = value.price;
    bookingPaymentData.assignedMaUserID = value.key;
    this.setState({ bookingPaymentData });
  }
  handleNotesChange = (event, { value }) => {
    const { modal } = this.state;
    modal.notes = value;
    this.setState({ modal });
  }
  handleCheckboxChange = (event, { checked }) => {
    const { modal } = this.state;
    modal.isCancelPending = checked;
    this.setState({ modal });
  }
  handleCheckBeforeClose = () => {
    if (this.form.state.uploads.length > 0) {
      const callback = () => {
        this.uploadModal.close();
      };
      const { store } = this.context;
      store.dispatch(promptChangesMessage({ message: UPLOAD_PICTURE_PROMPT, callback }));
      return true;
    }
    return false;
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedPicture: null,
      slideshow: false,
    });
  }
  handleViewLargeSlide = (e, data) => {
    e.preventDefault();
    this.setState({
      selectedPicture: data,
      showLarge: true,
      slideshow: true,
    });
  }
  handleSlidePicture = (e, direction = 'right') => {
    const { bookingPaymentData, selectedPicture } = this.state;
    const index = bookingPaymentData.paymentPictures.indexOf(selectedPicture);
    const nextIndex = direction === 'left' ? index - 1 : index + 1;
    this.setState({
      selectedPicture: bookingPaymentData.paymentPictures[nextIndex],
    });
  }
  checkDisabled(direction = 'right') {
    const { bookingPaymentData, selectedPicture } = this.state;
    if (bookingPaymentData.paymentPictures &&
      bookingPaymentData.paymentPictures.length > 0 &&
      selectedPicture) {
      const index = bookingPaymentData.paymentPictures.indexOf(selectedPicture);
      if (direction === 'left') {
        return index - 1 >= 0;
      }
      return index + 1 < bookingPaymentData.paymentPictures.length;
    }
    return false;
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    store.dispatch(replace(`/bookings/manage/?${encodeSearch(query)}`));
    this.fetchProjectUnitBookings(query);
  }
  pushQuery(query) {
    const { store } = this.context;
    store.dispatch(replace(`/bookings/manage/?${encodeSearch(query)}`));
    this.fetchProjectUnitBookings(query);
  }
  sortItems = [
    {
      text: 'Oldest Reserved Unit',
      icon: 'sort alphabet ascending',
      sortColumn: 'project_unit.latest_reserved_at',
      sortDirection: 'asc',
    },
    {
      text: 'Latest Reserved Unit',
      icon: 'sort alphabet descending',
      sortColumn: 'project_unit.latest_reserved_at',
      sortDirection: 'desc',
    },
  ];
  generateRowStyle = (array) => {
    const newArray = array;
    let i = 1;
    const hasMultiple = i !== array.length;
    array.forEach((booking, idx) => {
      if (!hasMultiple && i === array.length) newArray[idx].className = 'start end';
      if (hasMultiple && i === (array.length - (array.length - 1))) newArray[idx].className = 'start';
      if (hasMultiple && i === array.length) newArray[idx].className = 'end';
      i += 1;
    });
    return newArray;
  }
  render() {
    const query = decodeSearch(this.props.location.search);
    const { modal, paymentModal, bookingPaymentData, bookingPaymentToken, customerData, isDuplicate } = this.state;
    return (
      <Container>
        <Modal closeOnDimmerClick={false} closeOnDocumentClick={false} open={paymentModal.isOpen} size="large">
          <Header content={bookingPaymentData !== '' ? `${bookingPaymentData.bookingCustomer.title && `${bookingPaymentData.bookingCustomer.title} `}${bookingPaymentData.bookingCustomer.preferredName}'s Booking` : 'Manage Booking'} />
          <Modal.Content>
            { bookingPaymentData !== '' ?
              <Grid>
                <Dimmer active={this.state.loading} inverted>
                  <Loader inline="centered">Loading</Loader>
                </Dimmer>
                <Grid.Row style={{ padding: '0.5em 0em' }}>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Divider horizontal>
                      Management
                    </Divider>
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={6}>
                        <b>Assigned Staff</b>
                      </Grid.Column>
                      <Grid.Column width={10}>
                        <SearchStaff
                          onClear={this.handleStaffClear}
                          onSelect={this.handleStaffSelect}
                          selectedValue={this.getSelectedStaffValue()}
                        />
                      </Grid.Column>
                    </Grid>
                    <Grid verticalAlign="top">
                      <Grid.Column textAlign="left" width={6}>
                        <b>Notes</b>
                      </Grid.Column>
                      <Grid.Column width={10}>
                        <Form.TextArea
                          name="remarkInternal"
                          onChange={this.handlePaymentChange}
                          value={bookingPaymentData.remarkInternal}
                          style={{
                            padding: '.78571429em 1em',
                            border: '1px solid rgba(34,36,38,.15)',
                            borderRadius: '.28571429rem',
                            width: '100%'
                          }}
                        />
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row style={{ padding: '0.5em 0em' }}>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Divider horizontal>
                      Payment
                    </Divider>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={8} computer={8}>
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>Amount</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <Form.Input
                          fluid
                          name="paymentAmount"
                          onChange={this.handlePaymentChange}
                          type="tel"
                          placeholder="Amount"
                          value={bookingPaymentData.paymentAmount}
                        />
                      </Grid.Column>
                    </Grid>
                    <Divider style={{ margin: '0.5em 0' }} />
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>Outstanding</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        {
                          bookingPaymentData.paymentAmount ?
                            <LoanAmount
                              format="0,000,000.00"
                              amount={
                                bookingPaymentData.paymentAmount - centsToFloat(
                                  bookingPaymentData.paymentPaidCents,
                                )
                              }
                              prefix={<CurrencySymbol />}
                            />
                          : '-'
                        }
                      </Grid.Column>
                    </Grid>
                    <Divider style={{ margin: '0.5em 0' }} />
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>Payments Made</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <LoanAmount
                          format="0,000,000.00"
                          amount={centsToFloat(bookingPaymentData.paymentPaidCents)}
                          prefix={<CurrencySymbol />}
                        />
                      </Grid.Column>
                    </Grid>
                    <Divider style={{ margin: '0.5em 0' }} className="large-hide small-hide tablet-hide" />
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={8} computer={8}>
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>Status</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        {valueToText(PAYMENT_STATUSES, bookingPaymentData.paymentStatusID)}
                      </Grid.Column>
                    </Grid>
                    <Divider style={{ margin: '0.5em 0' }} />
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>Notes</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <Form.Input
                          fluid
                          name="paymentNotes"
                          onChange={this.handlePaymentChange}
                          placeholder="Notes"
                          value={bookingPaymentData.paymentNotes}
                        />
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <BookingFeePaymentList
                      bookingID={bookingPaymentData.id}
                      data={bookingPaymentData.bookingFeePayments || []}
                      listOnly
                      isSubModal
                      token={bookingPaymentToken || ''}
                    />
                  </Grid.Column>
                </Grid.Row>
                {
                  isDuplicate ? (
                    <Grid.Row>
                      <Grid.Column mobile={16} tablet={16} computer={16}>
                        <Container style={{ border: '2px solid red', textAlign: 'center', padding: '5px' }}>
                          <Label style={{ backgroundColor: 'transparent', color: 'red' }}>
                            Warning: Cheque reference number duplication detected. <br />
                            Please verify manually before approving/declining this reservation
                          </Label>
                        </Container>
                      </Grid.Column>
                    </Grid.Row>
                  ) : null
                }
                <Grid.Row style={{ padding: '0.5em 0em' }}>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Divider horizontal>
                      Purchaser Info
                    </Divider>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column mobile={16} tablet={16} computer={16}>
                    <Grid centered>
                      <Grid.Row>
                        <Grid.Column mobile={2} tablet={2} computer={2} textAlign="left">
                          <b>Name:</b>
                        </Grid.Column>
                        <Grid.Column mobile={8} tablet={8} computer={8} textAlign="left">
                          {bookingPaymentData.bookingCustomer.name}
                        </Grid.Column>
                      </Grid.Row>
                      {
                        customerData && (customerData.icFrontDocumentID !== '' || customerData.icBackDocumentID !== '') ? (
                          <div style={{ width: '100%' }}>
                            <Grid centered>
                              <Grid.Row>
                                <Grid.Column mobile={10} tablet={10} computer={10} textAlign="left">
                                  <b>IC Preview:</b>
                                </Grid.Column>
                              </Grid.Row>
                            </Grid>
                            {
                              customerData.icFrontDocument || customerData.icBackDocument ? (
                                <Grid>
                                  <Grid.Row>
                                    <Grid.Column mobile={16} tablet={16} computer={16}>
                                      <Grid centered>
                                        <Grid.Row style={{ paddingTop: 0, marginBottom: '3rem' }}>
                                          {
                                            customerData.icFrontDocument && customerData.icFrontDocument.name !== '' ? (
                                              <Grid.Column mobile={5} tablet={5} computer={5} style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                                {
                                                  customerData.icFrontDocument.name.toLowerCase().includes('.pdf') ? (
                                                    <div>
                                                      <Icon name="check circle" style={{ color: '#4183C4' }} />
                                                      <strong>
                                                        <a
                                                          href={AWSUrl(
                                                            this.props.appConfig,
                                                            customerData.icFrontDocument.key,
                                                          )}
                                                          target="_blank"
                                                        >
                                                          {customerData.icFrontDocument.name}
                                                        </a>
                                                      </strong>
                                                    </div>
                                                  ) : (
                                                    <LoadImage
                                                      centered
                                                      picture={customerData.icFrontDocument}
                                                      pictureSize={70}
                                                    />
                                                  )
                                                }
                                              </Grid.Column>
                                            ) : (
                                              <Grid.Column mobile={5} tablet={5} computer={5} style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                                <p>
                                                  <Icon name="exclamation circle" style={{ color: '#4183C4' }} />
                                                  IC Front is not uploaded
                                                </p>
                                              </Grid.Column>
                                            )
                                          }
                                          {
                                            customerData.icBackDocument && customerData.icBackDocument.name !== '' ? (
                                              <Grid.Column mobile={5} tablet={5} computer={5} style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                                {
                                                  customerData.icBackDocument.name.toLowerCase().includes('.pdf') ? (
                                                    <div>
                                                      <Icon name="check circle" style={{ color: '#4183C4' }} />
                                                      <strong>
                                                        <a
                                                          href={AWSUrl(
                                                            this.props.appConfig,
                                                            customerData.icBackDocument.key,
                                                          )}
                                                          target="_blank"
                                                        >
                                                          {customerData.icBackDocument.name}
                                                        </a>
                                                      </strong>
                                                    </div>
                                                  ) : (
                                                    <LoadImage
                                                      centered
                                                      picture={customerData.icBackDocument}
                                                      pictureSize={70}
                                                    />
                                                  )
                                                }
                                              </Grid.Column>
                                            ) : (
                                              <Grid.Column mobile={5} tablet={5} computer={5} style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                                                <p>
                                                  <Icon name="exclamation circle" style={{ color: '#4183C4' }} />
                                                  IC Back is not uploaded
                                                </p>
                                              </Grid.Column>
                                            )
                                          }
                                        </Grid.Row>
                                      </Grid>
                                    </Grid.Column>
                                  </Grid.Row>
                                </Grid>
                              ) : null
                            }
                          </div>
                        ) : null
                      }
                    </Grid>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            :
              <Loader inline="centered">Loading</Loader>
          }
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.handleClosePaymentModal} color="red">
              <Icon name="x" /> Cancel
            </Button>
            <Button onClick={this.handleSavePaymentModal} color="green">
              <Icon name="check" /> Save
            </Button>
          </Modal.Actions>
        </Modal>
        <Modal closeOnDimmerClick={false} open={modal.isOpen} basic size="small" className="booking-status-note">
          <Header icon={modal.headerIcon} content={modal.header} />
          <Modal.Content>
            <h4>{modal.message}</h4>
            <p>{modal.notes === '' ? 'Add' : 'Update'} Notes* (required)</p>
            <Form>
              <Form.TextArea
                name="remarkInternal"
                placeholder="Notes*"
                value={modal.notes}
                onChange={this.handleNotesChange}
              />
            </Form>
          </Modal.Content>
          <Modal.Actions>
            {
              modal.type === 'decline' &&
              <Checkbox
                label="Cancel all pending loan applications"
                checked={modal.isCancelPending}
                onChange={this.handleCheckboxChange}
              />
            }
            <Button onClick={this.handleCloseModal} basic color="red" inverted>
              <Icon name="remove" /> No
            </Button>
            <Button
              onClick={this.handleConfirm}
              color="green"
              inverted
              icon="checkmark"
              content={modal.actionButtonText}
            />
          </Modal.Actions>
        </Modal>
        <NavBar
          header={(this.state.count === 0) ? 'Manage' : <span>Manage &nbsp;<Label color="blue">{this.state.count}</Label></span>}
        />
        <Grid verticalAlign="middle">
          <Grid.Row>
            <Grid.Column>
              {/* Search Filters */}
              <SearchFilter
                advanceFilter={this.state.advanceFilter}
                isLoading={this.state.loading}
                onChange={this.handleFilterOnChange}
                onClose={this.handleClearFilter}
                search={this.state.search}
                setAdvanceFilter={this.handleSetAdvanceFilter}
                placeholder="Search..."
                leftNav={(
                  <PageNav
                    currentPage={this.state.currentPage}
                    count={this.state.count}
                    limit={this.state.limit}
                    offset={this.state.offset}
                    dataSize={this.state.data.length}
                    loading={this.state.loading}
                    onChange={this.handleChangePage}
                  />
                )}
                rightNav={(
                  <SortButton
                    floated="right"
                    loading={this.state.loading}
                    items={this.sortItems}
                    onSort={this.handleSortData}
                  />
                )}
              >
                <SearchList
                  filterName="projectFilter"
                  icon="find"
                  isActive={(query.projectFilter && query.projectFilter.length > 0) || false}
                  loading={this.state.loadingSearch}
                  noResultsMessage={this.state.noResultsMessage}
                  onChange={this.handleSearchProject}
                  onClose={this.handleClearFilter}
                  onSelect={this.handleSelectProject}
                  placeholder="Find Project"
                  results={this.state.findProjectResults}
                  value={this.state.projectFilter}
                />
              </SearchFilter>
            </Grid.Column>
          </Grid.Row>
          {/* List Data */}
          <Grid.Row className="app--listdata">
            <Grid.Column>
              <br className="large-hide" />
              <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
                <Loader inline="centered">Loading</Loader>
              </Dimmer>
              <Grid>
                <Grid.Row>
                  <Grid.Column textAlign="center" width={16}>
                    <Button
                      onClick={this.handleAutoReload}
                      compact
                      size="tiny"
                      icon={this.state.autoReload ? { name: 'toggle on', color: 'green' } : { name: 'toggle off', color: 'red' }}
                      content={`Auto Refresh ${this.state.autoReload ? 'On' : 'Off'}`}
                    />
                    <Button
                      color="blue"
                      onClick={this.handleRefreshData}
                      compact
                      size="tiny"
                      icon="refresh"
                      content="Refresh Now"
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              {
                this.state.data.length > 0 ?
                  <Grid columns={2} className="equal height">
                    <Grid.Row>
                      <Grid.Column width={16}>
                        <Table celled className="manage-bookings">
                          { this.state.data.length > 0 ?
                            <Table.Header className="mobile-hide">
                              <Table.Row>
                                <Table.HeaderCell>Booking</Table.HeaderCell>
                                <Table.HeaderCell>Purchaser</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right">SPA (<CurrencySymbol />)</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">Assigned</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">Created</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">Manage Booking</Table.HeaderCell>
                              </Table.Row>
                            </Table.Header>
                            : null
                          }
                          <Table.Body>
                            {
                              this.state.data.map(unitdata => (
                                unitdata.bookings ?
                                this.generateRowStyle(unitdata.bookings).map((data, idx) => (
                                  <Table.Row
                                    key={idx}
                                    id={data.id}
                                    className={data.className}
                                    positive={data.approve}
                                    negative={data.decline}
                                  >
                                    {
                                    data.approve || data.decline ?
                                      <Table.Cell collapsing>
                                        {data.approve ? <span className="large-hide small-hide tablet-hide" style={{ float: 'right' }}><Icon name="check" /> Approved</span> : ''}
                                        {data.decline ? <span className="large-hide small-hide tablet-hide" style={{ float: 'right' }}><Icon name="cancel" /> Cancelled</span> : ''}
                                        <Link to={`/bookings/${data.id}/`}>
                                          {unitdata.reference}
                                        , <br className="large-hide" />
                                          {unitdata.project.shortName}
                                        , <br />
                                          <small>{data.code}</small>
                                        </Link>
                                      </Table.Cell>
                                    :
                                      <Table.Cell collapsing>
                                        <Button
                                          className="large-hide small-hide tablet-hide"
                                          floated="right"
                                          compact
                                          size="mini"
                                          negative
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.handleOpenModal(
                                              unitdata.id,
                                              data.id,
                                              data.remarkInternal,
                                              'Decline',
                                              'remove',
                                              <span>Decline Reservation?
                                                <br /> {unitdata.reference}{', '}
                                                {unitdata.project.shortName}
                                              </span>,
                                              <span>
                                                {data.bookingCustomer.name}{'\'s '}
                                                reservation ({data.code}) will be cancelled.
                                              </span>,
                                              'decline',
                                          );
                                          }}
                                        >
                                          Decline
                                        </Button>
                                        <Button
                                          className="large-hide small-hide tablet-hide"
                                          floated="right"
                                          compact
                                          size="mini"
                                          color="green"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.handleOpenModal(
                                              unitdata.id,
                                              data.id,
                                              data.remarkInternal,
                                              'Approve',
                                              'checkmark',
                                              <span>Approve Booking?
                                                <br /> {unitdata.reference}{', '}
                                                {unitdata.project.shortName}
                                              </span>,
                                              <span>
                                                Approve {data.bookingCustomer.name}{'\'s '}
                                                reservation ({data.code}).
                                                { (unitdata.projectUnitBookingSummary &&
                                                  unitdata.projectUnitBookingSummary.reservedCount
                                                  > 1)
                                                  && <br />
                                                }
                                                { (unitdata.projectUnitBookingSummary &&
                                                  unitdata.projectUnitBookingSummary.reservedCount
                                                  > 1)
                                                  && 'All other reservations for this unit  will be set to unsuccessful reservation.'
                                                }
                                              </span>,
                                              'approve',
                                            );
                                          }}
                                        >
                                          Approve
                                        </Button>
                                        <Button
                                          className="large-hide small-hide tablet-hide"
                                          floated="right"
                                          compact
                                          size="mini"
                                          icon
                                          onClick={
                                            () => this.handleOpenPaymentModal(data.id, unitdata.id)
                                          }
                                        >
                                          <Icon name="pencil" />
                                        </Button>
                                        <Link to={`/bookings/${data.id}/`}>
                                          {unitdata.reference}
                                        , <br className="large-hide" />
                                          {unitdata.project.shortName}
                                        , <br />
                                          <small>{data.code}</small>
                                        </Link>
                                      </Table.Cell>
                                    }
                                    <Table.Cell className="mobile-hide">
                                      <span className="mobile-hide">
                                        <Link to={`/bookings/${data.id}/`}>{data.bookingCustomer.name}</Link>
                                      </span>
                                    </Table.Cell>
                                    <Table.Cell collapsing className="mobile-hide" textAlign="right">
                                      <div className="mobile-hide">
                                        <small>
                                          {data.paymentStatus.name}
                                        </small>
                                        <br />
                                        <LoanAmount
                                          format="0,000,000.00"
                                          amount={spaFullNumber(data) || data.spaValue}
                                          prefix={<CurrencySymbol />}
                                        />
                                      </div>
                                    </Table.Cell>
                                    <Table.Cell collapsing textAlign="right">
                                      <span style={{ float: 'left' }} className="large-hide small-hide tablet-hide">
                                        <Link to={`/bookings/${data.id}/`}>{data.bookingCustomer.name}</Link>
                                      </span>
                                      <small className="large-hide small-hide tablet-hide">
                                        <i>{data.assignedMaPreferredName ? `Assigned: ${data.assignedMaPreferredName}` : <span>&nbsp;</span>}</i>
                                      </small>
                                      <span className="mobile-hide" style={{ float: 'left' }}>
                                        <small>
                                          {
                                            data.assignedMaPreferredName ?
                                            data.assignedMaPreferredName :
                                            <Button
                                              className="mobile-hide"
                                              size="mini"
                                              disabled={data.approve || data.decline}
                                              onClick={
                                                () =>
                                                this.handleOpenPaymentModal(data.id, unitdata.id)
                                              }
                                            >
                                              <Icon name="add user" /> Assign
                                            </Button>
                                          }
                                        </small>
                                      </span>
                                    </Table.Cell>
                                    <Table.Cell collapsing textAlign="right">
                                      <small>
                                        <span style={{ float: 'left' }} className="large-hide small-hide tablet-hide">
                                          <b>SPA: </b>
                                          <LoanAmount
                                            format="0,000,000.00"
                                            amount={spaFullNumber(data) || data.spaValue}
                                            prefix={<CurrencySymbol />}
                                          /> ({data.paymentStatus.name})
                                        </span>
                                      </small>
                                      <i>
                                        <small>
                                          <span>by </span>
                                          { this.hasStaffAccess() ?
                                            <Link to={`/users/${data.maUserAffiliateID}/`} >
                                              {data.maCreatedByPreferredName}
                                            </Link>
                                            : data.maCreatedByPreferredName
                                          }

                                          <span className="large-hide small-hide tablet-hide">,</span><br className="mobile-hide" />
                                          <Timestamp
                                            timestamp={data.createdAt}
                                            precise
                                          />
                                        </small>
                                      </i>
                                    </Table.Cell>
                                    {
                                    data.approve || data.decline ?
                                      <Table.Cell
                                        collapsing
                                        className="mobile-hide"
                                        textAlign="center"
                                      >
                                        {data.approve ? <span><Icon name="check" /> Approved</span> : ''}
                                        {data.decline ? <span><Icon name="cancel" /> Cancelled</span> : ''}
                                      </Table.Cell>
                                    :
                                      <Table.Cell collapsing className="mobile-hide">
                                        <Button
                                          className="mobile-hide"
                                          size="mini"
                                          icon
                                          onClick={
                                            () => this.handleOpenPaymentModal(data.id, unitdata.id)
                                          }
                                        >
                                          <Icon name="pencil" />
                                        </Button>
                                        <Button
                                          className="mobile-hide"
                                          size="mini"
                                          color="green"
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.handleOpenModal(
                                              unitdata.id,
                                              data.id,
                                              data.remarkInternal,
                                              'Approve',
                                              'checkmark',
                                              <span>Approve Booking?
                                                <br /> {unitdata.reference}{', '}
                                                {unitdata.project.shortName}
                                              </span>,
                                              <span>
                                                Approve {data.bookingCustomer.name}{'\'s '}
                                                reservation ({data.code}).
                                                { (unitdata.projectUnitBookingSummary &&
                                                  unitdata.projectUnitBookingSummary.reservedCount
                                                  > 1)
                                                  && <br />
                                                }
                                                { (unitdata.projectUnitBookingSummary &&
                                                  unitdata.projectUnitBookingSummary.reservedCount
                                                  > 1)
                                                  && 'All other reservations for this unit  will be set to unsuccessful reservation.'
                                                }
                                              </span>,
                                              'approve',
                                            );
                                          }}
                                        >
                                          Approve
                                        </Button>
                                        <Button
                                          className="mobile-hide"
                                          size="mini"
                                          negative
                                          onClick={(e) => {
                                            e.preventDefault();
                                            this.handleOpenModal(
                                              unitdata.id,
                                              data.id,
                                              data.remarkInternal,
                                              'Decline',
                                              'remove',
                                              <span>Decline Reservation?
                                                <br /> {unitdata.reference}{', '}
                                                {unitdata.project.shortName}
                                              </span>,
                                              <span>
                                                {data.bookingCustomer.name}{'\'s '}
                                                reservation ({data.code}) will be cancelled.
                                              </span>,
                                              'decline',
                                          );
                                          }}
                                        >
                                          Decline
                                        </Button>
                                      </Table.Cell>
                                    }
                                  </Table.Row>
                                ))
                                :
                                null
                              ))
                            }
                          </Table.Body>
                        </Table>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                  : (
                    <Grid>
                      <Grid.Row>
                        <Grid.Column>
                          <Item style={{}}>
                            <Item.Content>
                              {
                              !this.state.loading ?
                                <Segment textAlign="center">
                                  <p>No pending bookings found.</p>
                                </Segment>
                              : ''
                              }
                            </Item.Content>
                          </Item>
                        </Grid.Column>
                      </Grid.Row>
                    </Grid>
                  )
                }
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <PageNav
                currentPage={this.state.currentPage}
                count={this.state.count}
                limit={this.state.limit}
                offset={this.state.offset}
                dataSize={this.state.data.length}
                loading={this.state.loading}
                onChange={this.handleChangePage}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default connect(ManageOld.mapStateToProps)(ManageOld);



// WEBPACK FOOTER //
// ./src/containers/Bookings/ManageOld.jsx